module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("88z0P"))).then(() => parcelRequire('d0iPb'));